<!-- 停水信息 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('停水范围')">
              <j-input :placeholder="$t('请输入停水范围')" v-model="queryParam.stopWaterRange"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('停水时间')">
              <a-range-picker v-model="date" format="YYYY-MM-DD" :placeholder="[$t('停水开始时间'), $t('停水结束时间')]" @change="onDateRangeChange" @ok="onOk" />
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="停水开始时间">
              <a-date-picker v-model="queryParam.stopWaterBegin" show-time placeholder="停水开始时间" valueFormat="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate" @change="onCalendarChange" style="width: 100%;" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="停水结束时间">
              <a-date-picker v-model="queryParam.stopWaterEnd" show-time placeholder="停水结束时间" valueFormat="YYYY-MM-DD HH:mm:ss"  :disabled-date="disabledDate2" @change="onCalendarChange2" />
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './modal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import moment from 'moment';
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      JInput
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/oa/oaStopWaterInformation/list",
          delete: "/jeecg-charge/oa/oaStopWaterInformation/delete",
          deleteBatch: "/jeecg-charge/oa/oaStopWaterInformation/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('停水范围'),
            align:"center",
            dataIndex: 'stopWaterRange',
            width:200,
            ellipsis: true,
          },
          {
            title: this.$t('停水原因'),
            align:"center",
            dataIndex: 'stopWaterCause',
            width:200,
            ellipsis: true,
          },
          {
            title: this.$t('开始时间'),
            align:"center",
            dataIndex: 'stopWaterBegin',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('结束时间'),
            align:"center",
            dataIndex: 'stopWaterEnd',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      onDateRangeChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          if(this.dateType == 1) {
            this.queryParam.stopWaterBegin = dateStrings[0]+' 00:00:00';
            this.queryParam.stopWaterEnd = dateStrings[1]+' 23:59:59';
          }else{
            this.queryParam.stopWaterBegin = dateStrings[0];
            this.queryParam.stopWaterEnd = dateStrings[1];
          }
        }else{
          if(this.queryParam['stopWaterBegin']) {
            delete this.queryParam['stopWaterBegin']
          }
          if(this.queryParam['stopWaterEnd']) {
            delete this.queryParam['stopWaterEnd']
          }
        }
      },
      disabledDate(current) {
          return current > moment(this.disabledCurrentEnd) // 大于当前日期不能选
      },
      disabledDate2(current) {
          return current < moment(this.disabledCurrentStart) // 小于当前日期不能选
      },
      onCalendarChange(value, mode) {
          this.disabledCurrentStart = mode
      },
      onCalendarChange2(value, mode) {
          this.disabledCurrentEnd = mode
      },
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({});
        });
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'edit');
        });
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>